import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_VENDOR_FILTER_LIST_API_URL } from '../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../features/axiosClient';
import { vendorsFilterFailure, vendorsFilterSuccess } from '../actions';

const vendorsFilterAPI = () => getApiRequest(`${PROOFREADER_VENDOR_FILTER_LIST_API_URL}`);

function* handleVendorsFilterAPI() {
  try {
    const response = yield call(vendorsFilterAPI);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorsFilterSuccess(response));
  } catch (error) {
    yield put(vendorsFilterFailure(error));
  }
}

export function* watchVendorsFilter() {
  yield takeLatest(types.GET_VENDORS_LIST_REQUEST, handleVendorsFilterAPI);
}
